import { FC } from 'react';

import { Icon } from '@components/index';
import {
  downloadLeadCsvFromPreview,
  downloadLeadTemplateWithLists
} from '@features/lead-management/utils/leadBulkDownloadTemplate';

import theme from '../../../../../../themes/colors';

interface LeadDownloadTemplateSectionProps {
  isFileAvailable: boolean;
  tableHeaders: string[];
  tableRows: any[];
  statuses: string[];
  sources: string[];
  tags: string[];
  categories: string[];
  priorities: string[];
  assignees: string[];
  cities: string[];
}

const LeadDownloadTemplateSection: FC<LeadDownloadTemplateSectionProps> = ({
  isFileAvailable,
  tableHeaders,
  tableRows,
  statuses,
  sources,
  tags,
  categories,
  priorities,
  assignees,
  cities
}) => {
  const onDownloadTemplate = () => {
    downloadLeadTemplateWithLists({
      statuses,
      sources,
      tags,
      categories,
      priorities,
      assignees,
      cities
    });
  };

  const onDownload = () => {
    downloadLeadCsvFromPreview(tableHeaders, tableRows);
  };

  return (
    <div className="flex items-center gap-x-1.5">
      <div
        className="flex cursor-pointer items-center gap-2 py-1.5 pr-4"
        role="presentation"
        onClick={isFileAvailable ? onDownload : onDownloadTemplate}
      >
        <Icon name="download" stroke={theme.primary} />
        <span className="text-sm font-medium text-primary">
          {isFileAvailable ? 'Download' : 'Download Template'}
        </span>
      </div>
    </div>
  );
};

export default LeadDownloadTemplateSection;
